import { FAQTopic } from '@components/FAQ';

import { Sections, Topics } from './constants';

const COVER_DETAILS_TOPICS: FAQTopic<Topics>[] = [
  {
    id: Topics.selfEmployed,
    question: "I'm self-employed, am I eligible for Income Protector?",
    answer: (
      <>
        Yes, we welcome self-employed customers. Full eligibility details and
        specifics are available in our terms and conditions.
      </>
    ),
  },
  {
    id: Topics.mulitipleJobs,
    question: 'I have more than one job, am I eligible for Income Protector?',
    answer: (
      <>
        Yes, provided you work at least 16 hours per week across all your roles.
        Please review the policy terms for more details.
      </>
    ),
  },
  {
    id: Topics.redundancy,
    question: "Can I make a claim if I'm made redundant?",
    answer: (
      <>
        Yes, if you’re made redundant through no fault of your own, you can
        claim. Please note that voluntary redundancies are not covered under
        this policy. Please review the policy terms to make sure the policy is
        suitable for your needs.
      </>
    ),
  },
  {
    id: Topics.movingAbroad,
    question: 'Can I make a claim if I move abroad?',
    answer: (
      <>
        No, currently, Income Protector is available to UK residents only. If
        you relocate and become a non-UK resident, please let us know.
      </>
    ),
  },
  {
    id: Topics.parentalLeave,
    question: 'What happens to my cover if I take parental leave?',
    answer: (
      <>
        Life changes happen, and you remain covered while on parental leave. If
        you become unemployed during this time, you’re still eligible to make a
        claim, provided you meet the standard policy criteria.
      </>
    ),
  },
  {
    id: Topics.existingCondition,
    question:
      'Can I make a claim related to an existing condition that prevented me from working?',
    answer: (
      <>
        Our policy covers new conditions only. Please check your policy schedule
        for full details on covered conditions.
      </>
    ),
  },
  {
    id: Topics.coverLength,
    question: 'How long am I covered for with this policy?',
    answer: (
      <>
        Income Protector renews every month until you cancel it or until you no
        longer meet the eligibility criteria
      </>
    ),
  },
];

const SWITCHING_TOPICS: FAQTopic<Topics>[] = [
  {
    id: Topics.existingPolicy,
    question: "Do I need to tell my current provider I'm leaving?",
    answer: (
      <>
        You will need to tell your current provider you are leaving as you
        cannot benefit from two or more insurance policies of the same type
      </>
    ),
  },
  {
    id: Topics.coverStart,
    question: 'When will my cover start?',
    answer: (
      <>
        <span>
          Your cover will start on the 1st of following month in which your
          account is created. If none of your other services are active at this
          point then your policy will begin on the 1st of the month following
          that of when the first of your other services becomes active.
        </span>

        <span>
          As an example, if you join UW on the 15th of May, and your first
          service commences on the 25th May, then Income Protector will start on
          the 1st June. However, if you first service starts on 3rd June, then
          your Income Protector will start on the 1st July.
        </span>
      </>
    ),
  },
];
const MAKING_A_CLAIM_TOPICS: FAQTopic<Topics>[] = [
  {
    id: Topics.claimProcess,
    question: 'How do I make a claim?',
    answer: (
      <>
        If you'd like to make an Income Protector claim, you'll need to call
        Davies Management Group on <a href="tel:03337773201">0333 777 3201</a>,
        or email them at{' '}
        <a href="mailto:utilitywarehouse.newclaims@davies-group.com">
          utilitywarehouse.newclaims@davies-group.com
        </a>
      </>
    ),
  },
  {
    id: Topics.claimFee,
    question: 'Do I have to pay a fee if I make a claim?',
    answer: <>There is no fee or excess to pay on an Income Protector claim</>,
  },
];

// https://docs.google.com/spreadsheets/d/1vDXs3653_M67vC8i_pg9msXayPtonOB0Ba61i_OZwPY
const faqSections = [
  {
    id: Sections.coverDetails,
    title: 'Cover details',
    topics: COVER_DETAILS_TOPICS,
  },
  {
    id: Sections.switching,
    title: 'Switching',
    topics: SWITCHING_TOPICS,
  },
  {
    id: Sections.makingAClaim,
    title: 'Making a claim',
    topics: MAKING_A_CLAIM_TOPICS,
  },
];

export { faqSections };
